import { JsonpInterceptor } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { jsonpFactory } from "@angular/http/src/http_module";
declare var appsettings;

//获取后台api接口配置  如果取到统一配置就使用统一配置 没取到使用本地配置
var config = window.top["config"] ? window.top["config"] : appsettings;

@Injectable()
export class AppSettingService {
  constructor() { }

  //获取http请求地址
  public getHttpUrl(): string {
    return config.httpUrl;
  }

  //获取登录权限
  public getLoginGatewayUrl(): string {
    return config.loginGatewayUrl;
  }

  //获取网关地址
  public getGatewayUrl(): string {
    return config.gatewayUrl;
  }

  //获取导出地址
  public getExportUrl(type: string): string {
    let GatewayUrl = config.GatewayUrl.split("api")[0];
    return `${GatewayUrl}api/export/${type}`;
  }

  //获取配置菜单名称
  public getMenuTitle(): string {
    let name = config.menuTitle ? config.menuTitle : "web平台";
    return name;
  }

  //获取打印地址
  public getPrintUrl(): string {
    return appsettings.printUrl;
  }

  //获取调试状态
  public getLocalDebug(): boolean {
    return appsettings.localDebug;
  }

  public userDebugRfidReader(): boolean {
    return config.userDebugRfidReader;
  }

  public getDefaultWeatherStationId(): string {
    return appsettings.defaultWeatherStationId;
  }

  public getDisplayVedio() {
    return appsettings.diplayVedio;
  }
  public getStations() {
    return appsettings.stations;
  }


  /**
   * 获取WebSeock服务器地址
   */
  public getWebSocketServer(): string {
    return config.WebSocketServer;
  }

  /**
   * 获取远程硬件配置地址
   */
  public getRFIDPrintConfig() {
    return config.RFIDPrint;
  }
  /**
   * 获取远程硬件配置地址
   */
  public getRFIDReaderConfig() {
    return config.RFIDReader;
  }
  public useDebugData(): boolean {
    return config.useDebugData;
  }

  public getFileUrl(filepath: string): string {
    return `${config.FileUrl}${btoa(filepath)}`;
  }
  getRequestInfoByAction(action: string) {
    action = action.toLowerCase();
    if (action == 'loginaction') {
      return {
        url: this.getLoginGatewayUrl(),
        service: "AuthCenter",
      };
    }
    for (var service in config.actionServiceMapper) {
      if (config.actionServiceMapper[service].indexOf(action) == -1) continue;
      return {
        url: service === "local" ? this.getHttpUrl() : this.getGatewayUrl(),
        service: service,
      };
    }
    return {
      url: this.getHttpUrl(),
      service: "local",
    };
  }

  //获取硬件服务下载地址
  public getEquDriverUrl(): string {
    return config.EquDriverUrl;
  }

  //获取云平台菜单
  public getMenu(): Array<any> {
    return config.menu;
  }

  public getHaiKangGatewayUrl(): string {
    return config.haiKangGatewayUrl;
  }
  public getRefreshTime(): number {
    return config.refreshTime;
  }

  public getWeatherRequestInterval(): number {
    return config.weatherRequestInterval;
  }
  //获取虫害统计种类数
  public getPestCount(): number {
    return config.pestCount;
  }

}
